import { Link } from "react-router";

interface FabProps {
  to: string;
  label: string;
}

export default function Fab({ to, label }: FabProps) {
  return (
    <Link
      to={to}
      className="fixed bottom-20 right-4 z-10 flex h-13 w-13 items-center justify-center rounded-xl bg-primary text-2xl font-light text-white shadow-lg shadow-primary/30 transition hover:bg-primary-dark"
      aria-label={label}
    >
      +
    </Link>
  );
}
